/*Import Estilo*/
import './index.scss';
import '../../css/global.css';
import '../../css/normalize.css';

/*Import Componentes*/
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';
import CookieAceite from '../../components/CookieAceite';

/*Import SEO*/
import { SEOHelmet } from '../../hooks/useSEO';

export default function SobreNos() {
    const seoData = {
        title: 'Sobre Nós - Fracaro Store',
        description: 'Conheça a história da Fracaro Store, uma empresa familiar com mais de 20 anos de experiência no mercado de vendas de artigos para casa.',
        keywords: 'fracaro store, sobre nós, história, empresa familiar, artigos para casa',
        url: window.location.href,
    };

    return (
        <section className='container-principal-sobre-nos'>
            <SEOHelmet {...seoData} />
            <Cabecalho />
            <CookieAceite />

            <main>
                {/* Hero */}
                <div className='hero-sobre'>
                    <div className='hero-overlay'>
                        <h1 className='hero-titulo'>Sobre Nós</h1>
                        <p className='hero-subtitulo'>Conheça a história por trás da Fracaro Store</p>
                    </div>
                </div>

                {/* Seção 1 - Nossa História */}
                <section className='secao-sobre secao-clara'>
                    <div className='secao-conteudo'>
                        <div className='secao-texto'>
                            <h2>Nossa História</h2>
                            <p>
                                A <strong>Fracaro Store</strong> nasceu do sonho de uma família apaixonada por proporcionar 
                                qualidade e conforto para os lares brasileiros. Com mais de <strong>20 anos de experiência</strong> no 
                                mercado de vendas, construímos uma trajetória sólida baseada na confiança e no 
                                compromisso com nossos clientes.
                            </p>
                            <p>
                                Ao longo dos anos, realizamos mais de <strong>10.000 pedidos</strong>, levando produtos de excelência 
                                para milhares de famílias. Cada entrega representa nosso comprometimento em 
                                oferecer o melhor em artigos para casa.
                            </p>
                        </div>
                        <div className='secao-imagem'>
                            <img src='/assets/image/zecaFracaroStore.svg' alt='Zeca, o mascote papagaio azul da Fracaro Store' />
                        </div>
                    </div>
                </section>

                {/* Seção 2 - O Que Fazemos */}
                <section className='secao-sobre secao-escura'>
                    <div className='secao-conteudo secao-invertida'>
                        <div className='secao-imagem'>
                            <img src='/assets/image/pessoaFracaroStore.svg' alt='Pessoa examinando o catálogo da Fracaro Store' />
                        </div>
                        <div className='secao-texto'>
                            <h2>O Que Fazemos</h2>
                            <p>
                                Vendemos artigos para casa com o cuidado e a atenção que sua família merece. 
                                Nosso catálogo conta com mais de <strong>150 produtos</strong>, incluindo jogos de cama, mesa e 
                                banho, tábuas de passar roupa, sapateiras, panos de chão e muito mais.
                            </p>
                            <p>
                                Trabalhamos diretamente com fornecedores confiáveis para garantir a melhor 
                                qualidade e os melhores preços. Cada produto é selecionado pensando no 
                                bem-estar e na praticidade do dia a dia.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Seção 3 - Nosso Compromisso */}
                <section className='secao-sobre secao-clara'>
                    <div className='secao-conteudo'>
                        <div className='secao-texto'>
                            <h2>Nosso Compromisso</h2>
                            <p>
                                Realizamos entregas em até <strong>3 dias</strong> na região da capital de São Paulo e 
                                Guarulhos, porque sabemos que agilidade faz a diferença. Nossa logística é 
                                pensada para que você receba seus produtos com rapidez e segurança.
                            </p>
                            <p>
                                Nosso time trabalha com dedicação para oferecer o melhor atendimento, 
                                desde a escolha do produto até o pós-venda. Estamos sempre prontos para 
                                ajudar!
                            </p>
                        </div>
                        <div className='secao-imagem'>
                            <img src='/assets/image/pitocoFracaroStore.svg' alt='Pitoco, o mascote cachorro da Fracaro Store em uma caixa de envios' />
                        </div>
                    </div>
                </section>

                {/* Valores */}
                <section className='secao-valores'>
                    <h2>Nossos Valores</h2>
                    <div className='valores-grid'>
                        <div className='valor-card'>
                            <div className='valor-icone'>
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z" fill="#131C46"/>
                                </svg>
                            </div>
                            <h3>Dedicação</h3>
                            <p>Cada cliente é único. Trabalhamos com carinho e atenção em cada pedido.</p>
                        </div>
                        <div className='valor-card'>
                            <div className='valor-icone'>
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z" fill="#131C46"/>
                                </svg>
                            </div>
                            <h3>Confiança</h3>
                            <p>Mais de 20 anos de mercado construindo relações duradouras com nossos clientes.</p>
                        </div>
                        <div className='valor-card'>
                            <div className='valor-icone'>
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="#131C46"/>
                                </svg>
                            </div>
                            <h3>Agilidade</h3>
                            <p>Entregas rápidas e eficientes para a região da Grande São Paulo.</p>
                        </div>
                        <div className='valor-card'>
                            <div className='valor-icone'>
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z" fill="#131C46"/>
                                </svg>
                            </div>
                            <h3>Família</h3>
                            <p>Somos uma empresa familiar que trata cada cliente como parte da nossa história.</p>
                        </div>
                    </div>
                </section>
            </main>

            <Rodape />
        </section>
    );
}
